import { createSlice } from "@reduxjs/toolkit";

// Custom deep merge
function deepMerge(target, source) {
  const output = { ...target };
  for (const key in source) {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key])
    ) {
      output[key] = deepMerge(target[key] || {}, source[key]);
    } else {
      output[key] = source[key];
    }
  }
  return output;
}

// Custom uniqBy
function uniqBy(array, key) {
  const seen = new Set();
  return array.filter((item) => {
    const val = item[key];
    if (seen.has(val)) return false;
    seen.add(val);
    return true;
  });
}

const customerDetails = createSlice({
  name: "customerDetails",
  initialState: {
    customerData: {},
    offers: [],
    redeemData: [],
    vouchers: [],
    brandList: [],
    countryList: [],
  },
  reducers: {
    addCustomerData: (state, action) => {
      state.customerData = action.payload;
    },
    updateCustomerData: (state, action) => {
      const incomingData = action.payload;

      state.customerData = deepMerge(state.customerData, incomingData);

      if (state.customerData.custom_fields?.field) {
        state.customerData.custom_fields.field = uniqBy(
          state.customerData.custom_fields.field,
          "name"
        );
      }
    },
    addOffers: (state, action) => {
      // state.offers = action.payload;
      const { categories, offers } = action.payload;

      // Check if 'offers' is an array before sorting
      if (Array.isArray(offers)) {
        // Sort the offers based on expiryDate (move expired offers to the bottom)
        const sortedOffers = offers.sort((a, b) => {
          const expiryA = new Date(a.expiry); // Parse expiry date of offer A
          const expiryB = new Date(b.expiry); // Parse expiry date of offer B

          // Ensure the expiry dates are valid
          const isExpiredA = expiryA < new Date();
          const isExpiredB = expiryB < new Date();

          // If both are expired or both are valid, retain their original order
          if (isExpiredA === isExpiredB) {
            return 0;
          }

          // Move expired offers to the bottom
          return isExpiredA ? 1 : -1;
        });

        // Update state with sorted offers and categories
        state.offers = { categories: categories, offers: sortedOffers };
      } else {
        // console.error("Expected offers to be an array, but got:", offers);
        state.offers = { categories: categories, offers: [] };
      }
    },

    addRedeemData: (state, action) => {
      state.redeemData = action.payload;
    },
    addVouchers: (state, action) => {
      state.vouchers = action.payload;
    },
    addBrandList: (state, action) => {
      const newBrands = action.payload;
      const existingBrands = state.brandList;

      // Merge new brands and existing brands, removing duplicates based on unique `id`
      const updatedBrandList = [
        ...existingBrands,
        ...newBrands.filter(
          (newBrand) =>
            !existingBrands.some(
              (existingBrand) => existingBrand.id === newBrand.id
            )
        ),
      ];

      state.brandList = updatedBrandList;
    },
    addCountryList: (state, action) => {
      state.countryList = action.payload;
    },
  },
});

export const {
  addCustomerData,
  addOffers,
  addRedeemData,
  addVouchers,
  addBrandList,
  updateCustomerData,
  addCountryList,
} = customerDetails.actions;
export default customerDetails.reducer;
